var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.dynamicComponent,_vm._g(_vm._b({tag:"component",attrs:{"label":_vm.translatedLabel,"rules":_vm.computedRules,"type":_vm.type}},'component',_vm.dynamicComponentProps,false),_vm.dynamicComponentListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }